export const RESET = 'EXSBINVOICETYPE_UPDATE_RESET'
export const SET_ERROR = 'EXSBINVOICETYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBINVOICETYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBINVOICETYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBINVOICETYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBINVOICETYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBINVOICETYPE_UPDATE_UPDATE_RETRIEVED'
